import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  HostListener
} from '@angular/core';
import { Device } from '../../../devices/device.model';
import { DevicesService } from '../../../devices/devices.service';
import { Device as Device_new } from '../../../devices/devices.model_new';
import { HomeService } from '../../home.service';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { SharedUtils } from '../../../../shared/shared.utils';
import { ApiService } from '../../../../core/services/api.service';
import { EnergyService } from '../../../energy/energy.service';
import { ENGINE_METHOD_DIGESTS } from 'constants';
import { DeviceType, STATE_VAR } from '../../../devices/devices.constant';
import { Observable } from 'rxjs/Observable';
import { RealTimeMessage } from '../../../devices/real-time-message.model';
import { StateVariables } from '../../../devices/state-variables.model';
import { cloneDeep } from 'lodash';
import { IotService } from '../../../../core/services/iot.service';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { HOUSE_COUNTRIES } from '../../../houses/houses.constants';

@Component({
  selector: 'app-home-cells-view',
  templateUrl: './home-cells-view.component.html',
  styleUrls: ['./home-cells-view.component.scss']
})
export class HomeCellsViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  gridInjection;
  @Input()
  selfConsumption;
  @Input()
  gridConsumption;
  @Input()
  realTimeMessage: any;
  @Input()
  consumptionSmartMeterIsOnline: boolean;
  @Input()
  atLeastOneProductionModuleIsOnline: boolean;
  @Input()
  injectionSmartMeterIsOnline: boolean;

  @ViewChild('cellsContainer')
  cellsContainer: ElementRef;
  @ViewChild('totalizersContainer')
  totalizersContainer: ElementRef;

  SharedUtils = SharedUtils;

  loadingCells = true;
  loadDonutChart = false;

  devices: Device_new[];

  totalConsumption = null;
  totalProduction = null;
  tariff: string;

  genDataset: any[] = [
    { color: '#a0d7f8', value: null },
    { color: '#287aab', value: null }
  ];
  consDataset: any[] = [
    { color: '#ffc7b2', value: null },
    { color: '#fb6059', value: null }
  ];
  storagePercentage;
  smartMeterId;

  consumptionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish
  }

  onlyConsumptionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    backdropBackgroundColour: 'rgba(0, 0, 0, 0)'
  }

  productionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    primaryColour: '#287aab',
    secondaryColour: '#287aab',
    tertiaryColour: '#287aab'
  }

  loadingConsumption: boolean = true;
  loadingProduction: boolean = true;
  loadingInjection: boolean = true;

  constructor(
    private devicesService: DevicesService,
    private homeService: HomeService,
    private energyService: EnergyService,
    private sessionStateService: SessionStateService,
    private iotService: IotService
  ) { }

  ngOnInit() {
    this.loadClientTariff();
    /** Get Battery */
    if (this.isStorageClient()) {
      this.devicesService.getEnergyStorage(this.sessionStateService.getHouse().houseId).subscribe(storage => {
        if (storage[0]) {
          this.energyService.getBatteryStatus(Number(storage[0].getModuleLocalId())).subscribe(val => {
            this.storagePercentage = val;
          });
        }
      });
    }
    // ** Get Smart Reader */
    this.loadingCells = true;
    this.getCellsDevices()
      .finally(() => {
        this.loadingCells = false;
      })
      .subscribe((resDevices: Device_new[]) => {
        resDevices.forEach((d: Device_new) => {
          if (d.isStateVarSupported('activePowerAplus')) {
            d.setStateVar('activePowerAplus', 0);
          }
        });
        this.iotService.responseHistory.forEach((message, moduleLocalId) => {
          const device = resDevices.find(initialDevice => initialDevice.getModuleLocalId() === moduleLocalId);
          if (device !== undefined) {
            if (message.platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
              if (device.getStateVar(message.platformKey) !== undefined) {
                device.getStateVar(message.platformKey).value = message.value;
              }
            } else {
              device.setConnectivityState(message.value);
            }
          }
        });
        this.devices = resDevices;
      });
    this.getSmartMeter();
    setTimeout(() => {
      if (this.totalizersContainer !== undefined) {
        this.loadDonutChart = true;
      }
    }, 100);
  }

  ngOnChanges() {
    if (this.realTimeMessage) {
      // console.log(this.realTimeMessage);
      this.updateDevicesList(this.realTimeMessage);
    }
    this.getValues();

    // Needed since in JS null + null = 0 -.-'
    if(this.gridConsumption !== null || this.selfConsumption !== null) {
      this.totalConsumption = this.gridConsumption + this.selfConsumption;
    }

    // Update Loadings
    // Validation of the other is online is to guarantee that both loadings are spinning in a sync way
    this.loadingConsumption = this.totalConsumption === null && (this.consumptionSmartMeterIsOnline === undefined || this.consumptionSmartMeterIsOnline === true);
    this.loadingProduction = this.totalProduction === null && this.selfConsumption === null && (this.atLeastOneProductionModuleIsOnline === undefined || this.atLeastOneProductionModuleIsOnline === true);
    this.loadingInjection = this.gridInjection === null && (this.injectionSmartMeterIsOnline === undefined || this.injectionSmartMeterIsOnline === true);
  }

  isOnlyConsumption(): boolean {
    return this.homeService.isOnlyConsumption();
  }

  isConsumptionES(): boolean {
    return this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN;
  }

  isAutoConsumption(): boolean {
    return (
      this.homeService.isAutoConsumption() ||
      this.homeService.isAutoConsumptionWithBattery()
    );
  }

  isMicroGeneration(): boolean {
    return this.homeService.isMicroGeneration();
  }

  private valueToPercentage(value: number, total: number) {
    return (value / total) * 100;
  }

  getValues(): void {
    if (
      this.homeService.isAutoConsumption() ||
      this.homeService.isAutoConsumptionWithBattery()
    ) {
      this.genDataset = [
        { color: '#a0d7f8', value: this.gridInjection },
        { color: '#287aab', value: this.selfConsumption }
      ];

      this.consDataset = [
        { color: '#fb6059', value: this.gridConsumption },
        { color: '#ffc7b2', value: this.selfConsumption }
      ];
    } else if (this.homeService.isMicroGeneration()) {
      this.genDataset = [
        { color: '#a0d7f8', value: 0 },
        { color: '#287aab', value: this.gridInjection }
      ];

      this.consDataset = [
        { color: '#fb6059', value: this.gridConsumption  },
        { color: '#ffc7b2', value: 0}
      ];
    }
  }

  private getCellsDevices(): Observable<any> {
    return this.devicesService.getHouseModules(
      this.sessionStateService.getHouse().houseId,
      DeviceType.CONSUMPTION
    );
  }

  loadClientTariff() {
    const houseId = this.sessionStateService.getHouse().houseId;
    this.homeService.getHouseTariff(houseId).subscribe(data => {
      this.tariff = data;
    });
  }

  getSmartMeter() {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.devicesService.getSmartMeter(houseId)
      .subscribe(response => {
        if (response[0]) {
          this.smartMeterId = response[0]['moduleLocalId'];
          // this.tariff = response[0].getStateVar('currentTariff') ? response[0].getStateVar('currentTariff').value : '';
        }
      }, error => {
        // this.homeService.getHouseTariff(houseId).subscribe(res => {
        //   return this.tariff = res;
        // });
      });
  }

  getCellsContainerLen(): number {
    return Math.min(
      this.cellsContainer.nativeElement.offsetWidth,
      this.cellsContainer.nativeElement.offsetHeight
    );
  }

  getTotalizersContainerLen(): number {
    return Math.min(
      this.totalizersContainer.nativeElement.offsetWidth,
      this.totalizersContainer.nativeElement.offsetHeight
    );
  }

  updateDevicesList(message: any) {
    const oldDevices = cloneDeep(this.devices);
    if (oldDevices !== undefined) {
      const device = oldDevices.find(element => element.getModuleLocalId() === message.moduleLocalId);
      if (device !== undefined) {
        if (message.platformKey !== STATE_VAR.TOTAL_ACTIVE_ENERGY_A_MINUS) {
          this.totalProduction = message.value;
        }
        if (message.platformKey !== STATE_VAR.ACTIVE_POWER_A_MINUS) {

        }
        if (message.platformKey !== STATE_VAR.ACTIVE_POWER_A_PLUS) {
          if (message.moduleLocalId === this.smartMeterId) {
            this.gridConsumption = message.value;
          }
        }
        if (message.platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
          if (device.getStateVar(message.platformKey) !== undefined) {
            device.getStateVar(message.platformKey).value = message.value;
          }
        } else {
          device.setConnectivityState(message.value);
        }
        this.devices = oldDevices;
      }
    }
  }

  ngOnDestroy() {
    
  }

  isStorageClient() {
    return this.energyService.isStorageClient();
  }

  getBatteryIcon(val) {
    const percentage = Number(val);
    if (percentage > 85 && percentage <= 100) {
      return 'assets/img/icons/ic_battery_full.svg';
    } else if (percentage >= 75 && percentage <= 85) {
      return 'assets/img/icons/ic_battery_75.svg';
    } else if (percentage <= 75 && percentage > 50) {
      return 'assets/img/icons/ic_battery_50.svg';
    } else if (percentage <= 50 && percentage > 25) {
      return 'assets/img/icons/ic_battery_25.svg';
    } else if ( percentage < 25 && percentage >= 1) {
      return 'assets/img/icons/icon-low-battery.svg';
    } else if (percentage === 0) {
      return 'assets/img/icons/ic_battery_empty.svg';
    }
  }

  getStorageValue() {
    return this.storagePercentage;
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-cells-view/home-cells-view.component.ts